import { IOrganization } from '@/types/IOrganization';
import IResource from '@/types/IResource';
import { FormControl, FormHelperText, FormLabel } from '@chakra-ui/react';
import { t } from 'i18next';
import Select from 'react-select';
import { useCollaboratorsController } from './collaborators-section.controller';

interface IProps {
	resource: IResource;
	organizations: Array<IOrganization>;
	onChange: (updates: Partial<IResource>) => void;
}

export default function SectionCollaborators(props: IProps) {
	const { form, options } = useCollaboratorsController(props);

	return (
		<FormControl>
			<FormLabel mt={8} mb={4}>
				{t('Choose who can see this availability')}
			</FormLabel>

			<Select
				placeholder={t('Select organizations')}
				isClearable
				isMulti
				getOptionLabel={(org) => org.name}
				getOptionValue={(org) => org.id}
				options={options}
				value={form.watch('collaborators')}
				onChange={(v) => {
					// TODO: Research this error...
					form.setValue('collaborators', v as unknown as Array<IOrganization>);
					props.onChange({
						...props.resource,
						collaborators: v.map((v) => ({ type: 'ORGANIZATION', organizationId: v.id })),
					});
				}}
			/>
			<FormHelperText>
				{t('Selected org members can link this availability to reservation calendars but cannot view or modify it.')}
			</FormHelperText>
		</FormControl>
	);
}
